import './CustomerFooter.css';

export default function CustomerFooter() {
  return <footer className="customer-footer" />;
}
